export const LOAD_CONTACT_ATTRIBUTES = 'LOAD_CONTACT_ATTRIBUTES';
export const CREATE_CONTACT_ATTRIBUTE = 'CREATE_CONTACT_ATTRIBUTE';
export const UPDATE_CONTACT_ATTRIBUTE = 'UPDATE_CONTACT_ATTRIBUTE';
export const ARCHIVE_CONTACT_ATTRIBUTE = 'ARCHIVE_CONTACT_ATTRIBUTE';

